import css from './Overlay.module.css';

function Overlay({ children }) {
    return (
        <div className={css.overlay}>
            <div className={css.main}>{children}</div>
        </div>
    );
}

export default Overlay;
